import axios from "axios";
import { API } from "../../utils/index";

const instance = axios.create();

export const getTexts = async () => {
  return instance.get(`${API}/text`);
};
